<template>
    <div class="container list-container is-fluid is-flex is-flex-direction-column">
        <h1>Mein Kundenkonto</h1>
        <div class="list-section">
            <div v-if="userData.lastName.length === 0">
                <p class="list-title">Name</p>
                <p class="notranslate">{{ userData.firstName }}</p>
            </div>
            <div v-else>
                <p class="list-title">Name, Vorname</p>
                <p class="notranslate">{{ userData.lastName }}, {{ userData.firstName }}</p>
            </div>
        </div>
        <div class="list-section">
            <p class="list-title">Kundennummer</p>
            <p class="notranslate">{{ customerNumber }}</p>
        </div>

        <div class="list-section">
            <p class="list-title">Adresse</p>
            <p class="notranslate">{{ userData.firstName }} {{ userData.lastName }}</p>
            <p class="notranslate">{{ userData.address }}</p>
            <p class="notranslate">{{ userData.zipCode }} {{ userData.city }}</p>
        </div>

        <div class="list-section">
            <p class="list-title">Telefon</p>
            <p class="notranslate">{{ userData.phone }}</p>
        </div>

        <div class="list-section">
            <p class="list-title">E-Mail</p>
            <p class="notranslate">{{ userData.email }}</p>
        </div>

        <div class="buttons-with-gap is-flex is-flex-direction-row is-flex-wrap-wrap">
          <Button text="Passwort ändern" @click="$router.push('/passwort-aendern')"/>
          <Button text="Kundenkonto löschen" @click="showDeleteAccountModal"/>
        </div>
    </div>
    <Modal v-show="deleteModalVisible" :onClose="hideDeleteAccountModal" :modalContentSizeClass="'delete-account-modal-width'">
      <div v-if="deleteAccountError" class="error">
        Es trat ein Fehler bei der Beantragung der Kontolöschung auf. Bitte versuchen Sie es später erneut oder
        kontaktieren Sie unseren Kundenservice.
      </div>
      <div v-else-if="deleteAccountSuccess">
        Die Löschung Ihres Kundenkontos wurde erfolgreich beantragt.
      </div>
      <div v-else class="delete-account-modal-content">
        <h1>Kundenkonto löschen</h1>
        <p :class="deleteAccountCustomerNumberDoesNotMatch ? 'error' : ''">
          Bitte bestätigen Sie die Löschung Ihres Kundenkontos durch Eingabe Ihrer Kundennummer. Die Löschung Ihres
          Kundenkontos wird bei Klick auf "Kundenkonto löschen" durchgeführt und Sie werden ausgeloggt. Sie könnnen sich
          danach nicht mehr anmelden.
        </p>

        <div class="delete-account-customer-number-input">
          <input class="input is-rounded"
                 :class="deleteAccountCustomerNumberDoesNotMatch ? 'error' : ''"
                 type="text"
                 placeholder="Kundennummer"
                 aria-label="Kundennummer"
                 v-model="deleteAccountCustomerNumberInput"
                 @keydown="this.deleteAccountCustomerNumberDoesNotMatch = false"
          >
        </div>


        <div class="buttons-with-gap is-flex is-flex-direction-row is-flex-wrap-wrap is-justify-content-flex-end mt-4">
          <Button class="button is-flex-grow-1" aria-label="Abbrechen" @click="hideDeleteAccountModal" text="Abbrechen"/>
          <Button class="button is-flex-grow-1" aria-label="Kundenkonto löschen" @click="deleteAccount" text="Kundenkonto löschen"/>
        </div>
      </div>
    </Modal>
</template>

<script>
import Button from "@/views/components/ui/Button"
import Modal from "@/views/components/ui/Modal"


export default {
    name: 'UserProfile',
    components: {
      Button,
      Modal
    },
    data() {
        return {
            customerNumber: '',
            userData: {},
            deleteModalVisible: false,
            deleteAccountCustomerNumberInput: '',
            deleteAccountCustomerNumberDoesNotMatch: false,
            deleteAccountError: false,
            deleteAccountSuccess: false
        }
    },
    beforeMount() {
        this.customerNumber = this.$store.getters.getUserList.customerNumber
        this.userData = this.$store.getters.getUserList.deliveryAddress
    },
    methods: {
        showDeleteAccountModal() {
            this.deleteAccountCustomerNumberInput = ''
            this.deleteAccountCustomerNumberDoesNotMatch = false
            this.deleteAccountError = false
            this.deleteAccountSuccess = false
            this.deleteModalVisible = true
        },
        hideDeleteAccountModal() {
             if (this.deleteAccountSuccess) {
                this.$router.push('/')
                return
             }

            this.deleteAccountCustomerNumberInput = ''
            this.deleteAccountCustomerNumberDoesNotMatch = false
            this.deleteAccountError = false
            this.deleteAccountSuccess = false
            this.deleteModalVisible = false
        },
        deleteAccount() {
            if (this.deleteAccountCustomerNumberInput !== this.customerNumber) {
                this.deleteAccountCustomerNumberDoesNotMatch = true;
                return;
            }

            this.$store.dispatch('requestAccountDeletionAndLogout')
                .then(() => {
                  this.deleteAccountSuccess = true
                })
                .catch(() => {
                    this.deleteAccountError = true;
                });
        }
    }
}
</script>

<style lang="scss">
.list-container {
    min-height: calc(100vh - 200px);
    background-color: $secondary;

    h1 {
        font-size: $fontsize-headline5;
        font-weight: $font-weight-black;
        margin-top: 1rem;
    }
}

.list-section {
    margin: .5rem 0;
    .list-title {
        font-weight: $font-weight-bold
    }
}

.buttons-with-gap {
    gap: $gap;
}

.delete-account-modal-content {
    h1 {
        font-size: $fontsize-headline5;
        font-weight: $font-weight-black;
        margin-bottom: 1rem;
    }

    .delete-account-customer-number-input {
        max-width: 300px;

        input.error {
            border-color: $warning-color;
            box-shadow: 0 0 0 1px $warning-color;
        }
    }

}

.delete-account-modal-width {
}



.error {
  color: $warning-color;
}

@media all and (min-width: $desktop) {
    .container {
        &.space-for-footer {
            &::before {
                content: "";
                height: 0;
                box-shadow: none;
            }

            .container {
                &.header {
                    padding-top: 20px;
                }
            }

        }

    }
}
</style>
